import React from 'react'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import { emailSchema } from '@utils/validationSchemas'

const EmailStep = ({ isLoading, error, onSubmit }) => {
    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm({
        resolver: yupResolver(emailSchema),
        defaultValues: {
            email: '',
        },
    })

    return (
        <>
            <div className="employee-login-header">
                <h2>Employee Login</h2>
                <p>Enter your email to receive a verification code</p>
            </div>

            {error && (
                <div className="employee-login-alert employee-login-alert-danger">
                    <i className="bx bx-error-circle"></i>
                    {error}
                </div>
            )}

            <form onSubmit={handleSubmit(onSubmit)}>
                <div className="employee-login-form-group">
                    <label htmlFor="email">
                        <i className="bx bx-envelope"></i> Email
                    </label>
                    <input
                        id="email"
                        type="email"
                        {...register('email')}
                        className={`employee-login-form-control ${errors.email ? 'is-invalid' : ''}`}
                        placeholder="Enter your email address"
                        autoComplete="email"
                        disabled={isLoading}
                    />
                    {errors.email && <div className="employee-login-invalid-feedback">{errors.email.message}</div>}
                </div>

                <button type="submit" className="employee-login-btn-submit" disabled={isLoading}>
                    {isLoading ?
                        <>
                            <i className="bx bx-loader-alt bx-spin"></i> Sending...
                        </>
                    :   'Send Verification Code'}
                </button>
            </form>
        </>
    )
}

export default EmailStep
